import { render, staticRenderFns } from "./DirectionsUniversity.vue?vue&type=template&id=cc7abf56&scoped=true&"
import script from "./DirectionsUniversity.vue?vue&type=script&lang=js&"
export * from "./DirectionsUniversity.vue?vue&type=script&lang=js&"
import style0 from "./DirectionsUniversity.vue?vue&type=style&index=0&id=cc7abf56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7abf56",
  null
  
)

export default component.exports